import { useMemo } from 'react';
import { DateTime } from 'luxon';

export function useDateTimeDisplay(value: string, format: string = 'yy.MM.dd HH:mm:ss') {
  return useMemo(() => DateTime.fromISO(value).toFormat(format), [value, format]);
}
